import{createContext}from"react";import{RouterLink}from"../components/router-link/router-link.js";const RouterLinkContext=createContext(RouterLink);export{RouterLinkContext};
